import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { LOCAL_LANGUAGE_CODE } from './constant/text';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: ['sv'],
    supportedLngs: ['sv', 'en', 'no', 'de'],
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: LOCAL_LANGUAGE_CODE,
      caches: ['localStorage'],
    },
    // have a retts namespace used around the full app
    ns: ['common'],
    defaultNS: 'common',
    fallbackNS: 'common',
    debug: false,
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?${process.env.REACT_APP_VERSION}`,
    },
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    react: {
      wait: true,
    },
  });

export default i18n;
